import React, { useContext, useEffect, useRef, useState } from "react";
import "./Television.css";
import { Context } from "../../../context/Context";
import ErrorToast from "../../toasts/ErrorToast";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import NumbersModal from "../../modals/NumbersModal";

const Television = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  setData,
}) => {
  const { handleNumbersModal, equipmentButtons, devices } = useContext(Context);
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(
    //     data.equipment_buttons.map((button) => ({
    //       button,
    //     }))
    //   );
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id),
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (digit, icon) => {
    // Get button Info
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    //   digit,
    // }).then(({ data }) => {
    //   if (
    //     data.equipment_buttons.length &&
    //     data.equipment_buttons[0].data1 &&
    //     data.equipment_buttons[0].data2 &&
    //     data.equipment_buttons[0].data3 &&
    //     data.equipment_buttons[0].data4 &&
    //     data.equipment_buttons[0].data5
    //   ) {
    //     setData({
    //       icon,
    //       name: null,
    //       data: [
    //         2,
    //         5,
    //         data.equipment_buttons[0].data1,
    //         data.equipment_buttons[0].data2,
    //         data.equipment_buttons[0].data3,
    //         data.equipment_buttons[0].data4,
    //         data.equipment_buttons[0].data5,
    //       ],
    //       device: data.equipment_buttons[0].device,
    //     });
    //     closeSelectEquipmentRef.current.click();
    //     closeSelectOutputEquipmentRef.current.click();
    //   } else {
    //     ErrorToast("کلید تعریف نشده است");
    //   }
    //   setIsLoading(false);
    // });

    let button = equipmentButtons.find(
      (eq_btn) => eq_btn.equipment_id == equipment_id && eq_btn.digit == digit,
    );
    let device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    if (
      button &&
      button.data1 &&
      button.data2 &&
      button.data3 &&
      button.data4 &&
      button.data5
    ) {
      setData({
        icon,
        name: null,
        data: [
          2,
          5,
          button.data1,
          button.data2,
          button.data3,
          button.data4,
          button.data5,
        ],
        device: device,
      });
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    } else {
      ErrorToast("کلید تعریف نشده است");
    }
  };

  return (
    <>
      <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
        <div
          className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
          style={{ zIndex: 1, top: "0" }}
        >
          <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
          <div>{/* <BackButton url={'/room/' + room_id}  /> */}</div>
        </div>
        <div className="card-body scrollbar">
          {/* <SimpleBar style={{ maxHeight: "100%", padding: '1.5rem' }}> */}
          <div className="keys rounded-3">
            <p className="text-center m-0" style={{ fontSize: "11px" }}>
              S/{devices.find((d) => d.id == buttons?.[0]?.device_id)?.serial}
            </p>
            <div className="d-flex justify-content-around">
              <div
                className="top-keys"
                onClick={() => handleClickButton(2, 34)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 2 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/kd-on.png"
                      : "/assets/img/app-icons/kd.png"
                  }
                />
              </div>
              <div
                className="top-keys"
                onClick={() => handleClickButton(1, 35)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 1 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/Lk-on.png"
                      : "/assets/img/app-icons/Lk.png"
                  }
                />
              </div>
              <div
                className="top-keys"
                onClick={() => handleClickButton(0, 36)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 0 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/df-on.png"
                      : "/assets/img/app-icons/df.png"
                  }
                />
              </div>
            </div>
            <div className="center-keys">
              <div
                className="position-absolute"
                style={{ top: "12px", right: "calc(50% - 3px)" }}
                onClick={() => handleClickButton(3, 20)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 3 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/mU1-on.png"
                      : "/assets/img/app-icons/mU1.png"
                  }
                  style={{ width: "6px" }}
                />
              </div>
              <div
                className="position-absolute"
                style={{ top: "calc(50% - 12px)", right: "15px" }}
                onClick={() => handleClickButton(6, 20)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 6 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/mU1-on.png"
                      : "/assets/img/app-icons/mU1.png"
                  }
                  style={{ width: "6px" }}
                />
              </div>
              <div
                className="position-absolute"
                style={{ top: "calc(50% - 12px)", left: "15px" }}
                onClick={() => handleClickButton(4, 20)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 4 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/mU1-on.png"
                      : "/assets/img/app-icons/mU1.png"
                  }
                  style={{ width: "6px" }}
                />
              </div>
              <div
                className="position-absolute"
                style={{
                  top: "calc(50% - 30px)",
                  right: "calc(50% - 30px)",
                  backgroundColor: "rgb(221, 221, 221)",
                  borderRadius: "50%",
                }}
                onClick={() => handleClickButton(5, 40)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 5 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/Aq-on.png"
                      : "/assets/img/app-icons/Aq.png"
                  }
                  style={{ width: "60px" }}
                />
              </div>
              <div
                className="position-absolute"
                style={{ bottom: "12px", right: "calc(50% - 3px)" }}
                onClick={() => handleClickButton(7, 20)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 7 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/mU1-on.png"
                      : "/assets/img/app-icons/mU1.png"
                  }
                  style={{ width: "6px" }}
                />
              </div>
            </div>

            <div className="bottom-keys d-flex justify-content-between">
              <div onClick={() => handleClickButton(9, 42)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 9 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/16-on.png"
                      : "/assets/img/app-icons/16.png"
                  }
                />
              </div>
              <div onClick={() => handleClickButton(8, 43)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 8 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/uF-on.png"
                      : "/assets/img/app-icons/uF.png"
                  }
                />
              </div>
            </div>

            <div className="bottom-keys d-flex justify-content-between">
              <div onClick={() => handleClickButton(14, 44)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 14 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/FF-on.png"
                      : "/assets/img/app-icons/FF.png"
                  }
                />
              </div>
              <div onClick={() => handleClickButton(13, 45)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 13 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/hI-on.png"
                      : "/assets/img/app-icons/hI.png"
                  }
                />
              </div>
            </div>

            <div className="d-flex justify-content-around">
              <div
                className="end-keys"
                onClick={() => handleClickButton(11, 46)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 11 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/7u-on.png"
                      : "/assets/img/app-icons/7u.png"
                  }
                />
              </div>
              <div
                className="end-keys"
                onClick={(status) => handleNumbersModal(true)}
              >
                <img src="/assets/img/app-icons/bk.png" />
              </div>
              <div
                className="end-keys"
                onClick={() => handleClickButton(10, 47)}
              >
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 10 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/ew-on.png"
                      : "/assets/img/app-icons/ew.png"
                  }
                />
              </div>
            </div>
          </div>
          {/* </SimpleBar> */}
        </div>
      </div>
      <NumbersModal
        type={3}
        setData={setData}
        equip_id={equipment_id}
        closeSelectEquipmentRef={closeSelectEquipmentRef}
        closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
      />
    </>
  );
};

export default React.memo(Television);
